"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_places_autocomplete_1 = __importDefault(require("react-places-autocomplete"));
var PlacesAutocompleteOverride = /** @class */ (function (_super) {
    __extends(PlacesAutocompleteOverride, _super);
    function PlacesAutocompleteOverride() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleInputKeyDown = function (event) {
            /* eslint-disable indent */
            switch (event.key) {
                case 'Enter':
                    event.preventDefault();
                    _this.handleEnterKey();
                    break;
                // Adding a tab handler to trigger address selection. PlacesAutoComplete does not support tab
                // https://github.com/hibiken/react-places-autocomplete/issues/134
                case 'Tab':
                    event.preventDefault();
                    _this.handleEnterKey();
                    break;
                case 'ArrowDown':
                    event.preventDefault(); // prevent the cursor from moving
                    _this.handleDownKey();
                    break;
                case 'ArrowUp':
                    event.preventDefault(); // prevent the cursor from moving
                    _this.handleUpKey();
                    break;
                case 'Escape':
                    _this.clearSuggestions();
                    break;
            }
            /* eslint-enable indent */
        };
        return _this;
    }
    return PlacesAutocompleteOverride;
}(react_places_autocomplete_1.default));
exports.default = PlacesAutocompleteOverride;
